import {
  defaultApiBasicX,
  defaultApiBasicXLegacyToken,
  legacyApiAuth
} from '../../apis'
import type { IResponseService, ItemUser } from '../../interfaces'

type TResponseBrokers = {
  fullname: string
}[]

export interface IFindBroker {
  email: string
  fullname: string
  userId: number
  isPrime: boolean
  photo?: string
}

export const getBrokersByName = async ({
  name
}: {
  name: string
}): Promise<IResponseService<TResponseBrokers>> => {
  const response = await legacyApiAuth.get<TResponseBrokers>(
    `/v2.0.2/agency/brokers/search?name=${name}`
  )
  try {
    return {
      isSuccess: true,
      data: response
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const getFindBrokersByName = async ({
  name
}: {
  name: string
}): Promise<IResponseService<IFindBroker[]>> => {
  const response = await legacyApiAuth.get<IFindBroker[]>(
    `/v2.0.2/agency/find_brokers?name=${name}`
  )
  try {
    return {
      isSuccess: true,
      data: response
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const putReassignAdviser = async ({
  advisorId,
  propertyIds
}: {
  propertyIds: string[]
  advisorId: string | number
}) => {
  const response = await legacyApiAuth.put(
    `/v2.0.2/agency/broker/${advisorId}/reasign_property`,
    {
      property_ids: propertyIds
    }
  )
  try {
    return {
      isSuccess: true,
      data: response
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const patchReassignAdviserV2 = async ({
  propertyIds,
  userId
}: {
  propertyIds: string[]
  userId: number
}) => {
  const response = await defaultApiBasicXLegacyToken.patch(`/properties`, {
    propertyIds,
    action: 'REASSIGN_USER',
    targetUserId: userId
  })
  try {
    return {
      isSuccess: true,
      data: response
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const fetchListAgencyUsersV2 = async (): Promise<
  IResponseService<ItemUser[]>
> => {
  const response = await defaultApiBasicX.get<IResponseService<ItemUser[]>>(
    `/users-management/v2/users/catalog?onlyAgencyUsers=true`
  )

  try {
    return {
      isSuccess: true,
      data: response.data
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const fetchListAgencyUsersV3 = async (): Promise<
  IResponseService<ItemUser[]>
> => {
  const response = await defaultApiBasicX.get<IResponseService<ItemUser[]>>(
    `/users-management/v3/users/catalog?onlyAgencyUsers=true`
  )

  try {
    return {
      isSuccess: true,
      data: response.data
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}
